export default __webpack_public_path__ + "static/media/eyeclose.34c0ac16.svg";